import ParentsInformations from "./ParentsInformations.jsx";

export default ParentsInformations;
